const CylinderHead =() => {
    return (
        <>
        <h2>Affordable Cylinder Heads</h2>
        <p>Coming Soon</p>
        </>
    )
}
export default CylinderHead